import Segmentos from "./Segmentos";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withNotificationContext } from "js/notification-context";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import styles from "./styles.js";

const enhance = compose(
  withApollo,
  withNotificationContext,
  withRouter,
  withStyles(styles)
);

export default enhance(Segmentos);
